<template>
  <div class="withdrawal" :class="isScroll ? '' : 'isBackground'">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="select-account-container">
        <SelectAccount @onConfirmAccount="onConfirmAccount" />
      </div>
      <div v-if="useUSDT && useBank" class="bankList">
        <div class="itemTit">
          <span>取款方式</span>
          <div class="flex-center">
            <button
              v-if="useUSDT"
              style="margin-right: 10px"
              class="button"
              :class="{ active: withdrawMethod === 'USDT' }"
              @click="switchWithdrawMethod('USDT')"
            >
              电子钱包
            </button>
            <button class="button" :class="{ active: withdrawMethod === 'BANK' }" @click="switchWithdrawMethod('BANK')">
              银行卡
            </button>
          </div>
        </div>
      </div>
      <div class="layout">
        <div v-if="withdrawMethod === 'BANK' && useBank" class="bankList">
          <div class="itemTit">
            <span>取款至</span><span @click="goAddBankCard">添加新银行卡<img
              src="@/assets/images/template/a_top_return_r.png"
            ></span>
          </div>
          <div class="itemList">
            <div>
              <SelectBank :curr-bank="selectedBank" :bank-list="withdrawList" @onConfirmBank="onConfirmBank" />
            </div>
          </div>
        </div>
        <div v-if="useUSDT && withdrawMethod === 'USDT'" class="bankList">
          <div class="itemTit add-wallet-wrapper">
            <span>取款至</span>
            <div v-if="walletList.length === 0" class="add-wallet-container">
              <div class="add-wallet" @click="toggleAddWallet">
                <span>添加钱包+</span>
              </div>
              <!-- <span class="add-wallet-text">尚未注册钱包，<span class="red" @click="registerWallet">一键注册</span></span> -->
            </div>
            <div v-if="walletList.length > 0" class="select-wallet-container">
              <div
                v-for="(wallet, index) in walletList"
                :key="'wallet-options-' + index"
                class="wallet-selection"
                :class="{ 'is-active': selectedWalletIdx === index }"
                @click="switchWallet(index)"
              >
                <span
                  style="
                    text-align: center;
                    display: flex;
                    justify-content: center;
                  "
                >
                  {{ wallet.protocol }}
                  {{
                    wallet.walletAddress.replace(
                      /(\w{4})\w+(\w{4})/,
                      '$1 **** $2'
                    )
                  }}
                </span>
              </div>
              <div v-if="walletList.length < maxWallets" class="wallet-selection">
                <span
                  style="
                    text-align: center;
                    display: flex;
                    justify-content: center;
                  "
                  @click="toggleAddWallet"
                >添加钱包+</span>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            (withdrawMethod === 'USDT' && walletAddress !== '') ||
              (withdrawMethod === 'BANK' && withdrawList.length > 0)
          "
          class="amount"
        >
          <van-radio-group v-model="selectedWithdrawalType">
            <div
              v-if="selectedBank && selectedBank.bank !== 'alipay'"
              :class="{ 'fixed-amt-container': withdrawMethod == 'BANK' }"
              @click="selectBankMatchWithdrawal(true)"
            >
              <div class="w_title" :style="{ marginTop: withdrawMethod === 'USDT' ? '20px' : '0' }">
                <span>{{ withdrawMethod === 'BANK' ? '定额取款（人民币）' : '取款金额（美元)' }}</span>
                <div v-if="withdrawMethod === 'BANK'" class="reward-radio-container">
                  <van-radio name="fixedAmt" label-position="left">
                    <span class="reward-txt">
                      <BankMatchCampaignTip />
                      特惠通道: 限时 94% 高中奖率
                    </span>
                  </van-radio>
                </div>
              </div>
              <div v-if="withdrawMethod == 'BANK' && isMatching" class="amountList">
                <ul>
                  <li
                    v-for="(amountOption, index) in filteredAmountOptionList"
                    :key="`amount-option-cny-${index}`"
                    :class="{ checked: selectedAmountOptionIndex == index }"
                    @click="selectAmountOption(amountOption, index)"
                  >
                    <span>{{ amountOption }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="custom-amt-container" @click="selectBankMatchWithdrawal(false)">
              <div v-if="withdrawMethod == 'BANK'" class="w_title">
                <span v-if="selectedBank && selectedBank.bank !== 'alipay'">灵活取款（人民币）</span>
                <span v-else="">取款金额（人民币）</span>
                <van-radio v-if="selectedBank && selectedBank.bank !== 'alipay'" name="customAmt" />
              </div>
              <div v-if="withdrawMethod == 'BANK' && !isMatching" class="amountList">
                <ul>
                  <li
                    v-for="(noMatchAmountOption, index) in noMatchAmountOptionList"
                    :key="`no-match-amount-option-cny-${index}`"
                    :class="{ checked: selectedNoMatchAmountOptionIndex == index }"
                    @click="selectNoMatchAmountOption(noMatchAmountOption, index)"
                  >
                    <span>{{ noMatchAmountOption == Math.max(...noMatchAmountOptionList) ? `>${noMatchAmountOption}` :
                      noMatchAmountOption }}</span>
                  </li>
                </ul>
              </div>
              <div
                v-if="withdrawMethod != 'BANK' || withdrawMethod == 'BANK' && !isMatching && selectedNoMatchAmountOptionIndex == noMatchAmountOptionList.length - 1"
                class="inputAmount"
              >
                <span>{{ withdrawMethod === 'BANK' ? '¥' : '$' }}</span>
                <input
                  v-model="amount"
                  type="number"
                  min="0"
                  :placeholder="`最多可取${withdrawMethod === 'BANK' ? `${advisableCreditAmountInCNY}人民币` : `${advisableCreditAmount}美元` }`"
                  @keyup="onKeyUp"
                >
                <p @click="allWithdraw">全部提现</p>
              </div>
            </div>
          </van-radio-group>
          <div v-if="withdrawMethod == 'BANK' && !isMatching" class="warning" style="padding: 0">
            为保障安全快速到账，建议提现个位数和十位数不为零的金额
          </div>
          <div v-if="amount != ''" class="w_title">
            <p v-if="withdrawMethod === 'BANK'">
              温馨提示：今日美元汇率为{{ rate }}，包括手续费后，预计扣除账号额度美元<em>{{ amountPlusFeeInUSD }}</em>
            </p>
            <p v-else>
              温馨提示：今日美元汇率为{{ rate }}，扣除手续费后，预计到账{{
                getDisplayCurrencyText(targetCurrency)
              }}<em>{{ ratedAmountWithFee }}</em>，实际到账金额可能与此不一致。

            </p>
          </div>
        </div>
        <section class="fees-section" :class="{ 'fee-loading': gettingFees }">
          <div
            v-if="
              (withdrawMethod === 'USDT' && walletAddress !== '') ||
                (withdrawMethod === 'BANK' && withdrawList.length > 0)
            "
            class="fee"
          >
            <span @click="withdrawalNoticePop">手续费<img src="@/assets/images/template/remind.png"></span>
            <span v-if="withdrawMethod === 'BANK'">¥{{ amount == '' ? '0.00' : feeInCNY }}</span>
            <span v-else>{{ amount == '' ? '0.00' : fee }}</span>
          </div>
          <div class="instructions" @click="withdrawalInstructionsPop">大额取款须知 <img
            src="@/assets/images/template/remind.png"
          ></div>
          <!-- Alipay Warning Text Box -->
          <div v-if="withdrawMethod === 'BANK' && selectedBank && selectedBank.bank === 'alipay'" class="warning-box">
            <svg class="warning-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
            <div>
              支付宝取款需较长时间，2小时内未必到账。您可能需要等待到下一个工作日资金才会到达，请耐心等候。
            </div>
          </div>
          <div
            v-if="withdrawMethod === 'BANK' && withdrawList.length > 0"
            class="submit"
            :class="{ suc: isBankSubmitEnabled }"
            @click="isBankSubmitEnabled ? submit() : null"
          >
            <p>提现</p>
          </div>
          <div
            v-else-if="walletAddress !== ''"
            class="submit"
            :class="{ suc: isUSDTSubmitEnabled }"
            @click="isUSDTSubmitEnabled ? submit() : null"
          >
            <p>提现 {{ getDisplayCurrencyText(targetCurrency) }}</p>
          </div>
          <div class="errMessage">
            <p>{{ errMessage }}</p>
          </div>

          <!-- 工商银行 + 银行风控 -->
          <div v-if="withdrawMethod == 'BANK'" class="warning" style="color: #000">
            温馨提示：<br><br>
            1. 请不要使用工商银行(广东省)操作取款, 以便资金快速到账, 您可绑定其他名下银行卡取款。<br><br>
            <span style="color: red">2. 因近期全国银行风控升级，针对所有转账审查严苛。建议取款时间9:00-18:00 ，并合并金额、减少取款次数，以免夜晚取款容易触发银行系统限制。</span>
          </div>
          <div v-if="withdrawMethod == 'USDT'" class="warning">
            温馨提示：请使用ERC20或TRC20链类型钱包进行取款，以便资金快速到账。
          </div>

          <div v-if="withdrawMethod == 'USDT'" class="warning">
            节假日USDT出金可能会延迟至当日17:00统一汇出, 敬请留意。
          </div>
        </section>
      </div>
    </div>
    <chat />
    <!--取款手续费须知-->
    <div v-if="isWithdrawalNoticePop" class="popFixed">
      <div class="masking" @click="withdrawalNoticePop" />
      <div class="tcCon">
        <div class="item">
          <span>取款手续费须知</span>
          <div class="explain">
            <!-- <p class="txtLeft">
              1、单笔取款50美元以下，公司将在汇款时扣取取款金额中的3美元作为取款手续费。
            </p> -->
            <p class="txtLeft">
              1、如客户注资后交易量不足注资金额的60%，及最后一次注资金额并未用于投资交易，将扣取提款金额的6%作为取款手续费。
            </p>
            <p class="txtLeft">
              2、完成交易量后, 24小时内最多可免费取款2次, 如24小时内取款第3次, 则每次取款需扣取取款金额的4%作为手续费用。
            </p>
            <div v-if="useUSDT && withdrawMethod === 'USDT'">
              <p class="txtLeft">
                3、 当取款低于50美元，需收取3美元手续费用。
              </p>
            </div>
          </div>
        </div>
        <div class="btnCon only">
          <span @click="withdrawalNoticePop">知道了</span>
        </div>
      </div>
    </div>
    <!--大额取款须知-->
    <div v-if="isWithdrawalInstructionsPop" class="popFixed">
      <div class="masking" @click="withdrawalInstructionsPop" />
      <div class="tcCon">
        <div class="item">
          <span>大额取款须知</span>
          <div class="explain">
            <!-- <p class="txtLeft">
              1、单笔取款50美元以下，公司将在汇款时扣取取款金额中的3美元作为取款手续费。
            </p> -->
            <!-- <p class="txtLeft">
              1. 公司会对于24小时内等于或大于2万美元的大额取款进行核实，相关部门不定期也会随机抽查审批核实。
            </p> -->
            <p class="txtLeft">
              相关部门不定期随机抽查，有机会需提供存款数据证明为本人入金。
              <br>
              <br>
              办公时间: 周一至周五 09:00-18:00
              <br>
              <br>
              申请取款一般当天可以审批完成，非办公时间、假期，需下一个工作日处理，有问题可以及时联系客服咨询。
            </p>
          </div>
        </div>
        <div class="btnCon only">
          <span @click="withdrawalInstructionsPop">知道了</span>
        </div>
      </div>
    </div>
    <!--存取款流程-->
    <DepositAndWithdrawal
      v-if="isDepositAndWithdrawal"
      :key="depositAndWithdrawalKey"
      :source="source"
      :this-page-type="pageType"
      :money-status="moneyStatus"
      @getFaceVal="getFaceVal"
    />
    <!--点击确认再次验证人脸-->
    <ButtonCertify v-if="isButtonCertify" :source="source" :button-data="buttonData" :money-status="moneyStatus" />
    <NewCanWithdrawalModule :show-alert-pop="showAlertPop" :can-withdraw="canWithdraw" @alertOnClose="alertOnClose" />
    <!-- 工商銀行 + 廣東省提示 -->
    <div v-if="showBankProvWarningPop" class="popFixed">
      <div class="masking" @click="closeBankProvWarningPop" />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p class="txtLeft">请使用其他银行银行卡或电子钱包取款， 以便资金快速到账。</p>
        </div>
        <div class="btnCon only">
          <span @click="closeBankProvWarningPop">我知道了</span>
        </div>
      </div>
    </div>
    <CampaignAlertPopup />
    <!-- 工商銀行 + 農業銀行沒有特惠通道提示 -->
    <div v-if="showNoMatchOnlyBankWarningPop" class="popFixed">
      <div class="masking" @click="closeNoMatchOnlyBankWarningPop" />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p class="txtLeft">工商银行不参与特惠活动。</p>
        </div>
        <div class="btnCon only">
          <span @click="closeNoMatchOnlyBankWarningPop">我知道了</span>
        </div>
      </div>
    </div>
    <!-- BEP20 提示 -->
    <div v-if="showBEP20WarningPop" class="popFixed">
      <div class="masking" @click="closeBEP20WarningPop" />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p class="txtLeft">BEP20链钱包取款暂停，请使用或添加其他链类型钱包。</p>
        </div>
        <div class="btnCon only">
          <span @click="closeBEP20WarningPop">我知道了</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require('@/assets/css/withdrawal.css')
import api from '@/plugins/api'
import { mapState } from 'vuex'
import { getDisplayCurrencyText } from '@/utils/helper.js'
import { MAX_WALLETS } from '@/utils/constants'

export default {
  name: 'Withdrawal',
  components: {
    Header: () => import(/* webpackChunkName: "header" */ '@/view/module/Header.vue'),
    Chat: () => import(/* webpackChunkName: "chat" */ '@/view/module/Chat.vue'),
    DepositAndWithdrawal: () => import(/* webpackChunkName: "depositAndWithdrawal" */ '@/view/module/DepositAndWithdrawal.vue'),
    ButtonCertify: () => import(/* webpackChunkName: "buttonCertify" */ '@/view/module/ButtonCertify.vue'),
    NewCanWithdrawalModule: () => import(/* webpackChunkName: "newCanWithdrawalModule" */ '@/view/module/NewCanWithdrawalModule'),
    SelectAccount: () => import(/* webpackChunkName: "selectAccount" */ '@/view/module/SelectAccount.vue'),
    SelectBank: () => import(/* webpackChunkName: "selectBank" */ '@/view/module/SelectBank.vue'),
    CampaignAlertPopup: () => import(/* webpackChunkName: "campaignAlertPopup" */ '@/view/module/CampaignAlertPopup.vue'),
    BankMatchCampaignTip: () => import(/* webpackChunkName: "bankMatchCampaignTip" */ '@/view/module/BankMatchCampaignTip.vue')
  },
  data() {
    const _this = this
    const u = navigator.userAgent
    return {
      title: '取款',
      rightContent: 'withdrawal',
      isWithdrawalNoticePop: false,
      isWithdrawalInstructionsPop: false,
      isDepositAndWithdrawal: true,
      moneyStatus: 'withdrawal',
      bankLogoList: process.env.VUE_APP_BANKLOGO,
      amount: '',
      withdrawList: [],
      rate: '', // 汇率
      bankCode: '', // 银行code
      bankNum: '', // 银行账号
      bankName: '', // 银行名称
      bankProvince: '',
      fee: '', // 手续费
      advisableCreditAmount: '', // 可取金额
      errMessage: '',
      identityStatus: false, // 证件照片
      bankProofStatus: false, // 银行卡证明
      addressStatus: false, // 地址证明
      credentialsStatus: false, // 手持证件照
      isWithdrawal: '',
      source: 'withdrawal',
      isScroll: '',
      buttonData: '',
      isButtonCertify: false,
      targetCurrency: 'CNY',
      chainType: 'ERC20', // 链类型
      isAndroid: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
      isIOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      isFaceValidate: true, // 是否需要人脸识别
      appObj: '',
      withdrawMethod: 'BANK',
      addingWallet: false,
      useUSDT: false,
      useBank: false,
      walletList: [],
      walletCompany: '',
      walletAddress: '',
      selectedWalletIdx: 0,
      canWithdraw: {
        bank: false,
        usdt: false
      },
      showAlertPop: false,
      getDisplayCurrencyText,
      gettingFees: false,
      minAmount: {
        bank: null, // CNY
        usdt: null // USD
      },
      maxAmount: {
        bank: null,
        usdt: null
      },
      showBankProvWarningPop: false,
      showNoMatchOnlyBankWarningPop: false,
      showBEP20WarningPop: false,
      amountOptionList: [],
      noMatchAmountOptionList: [],
      selectedAmountOptionIndex: -1,
      selectedNoMatchAmountOptionIndex: -1,
      selectedBank: null,
      depositAndWithdrawalKey: 0,
      isMatching: true
    }
  },
  computed: {
    ...mapState([
      'user',
      'gts2AccountId',
      'platform',
      'currency',
      'withdrawalData',
      'gts2CustomerId',
      'pageType',
      'sourceType'
    ]),
    selectedWithdrawalType: {
      get: function() {
        if (this.isMatching) {
          return 'fixedAmt'
        }

        return 'customAmt'
      },
      set: function(newValue) {
        this.amount = ''
        this.selectedAmountOptionIndex = -1
        this.selectedNoMatchAmountOptionIndex = -1
        if (newValue == 'fixedAmt') {
          this.isMatching = true
          return
        }

        this.isMatching = false
      }
    },
    ratedAmount: function() {
      return this.amount && this.amount !== ''
        ? Math.ceil(this.amount * this.rate)
        : '--'
    },
    ratedAmountWithFee: function() {
      return this.amount && this.amount !== ''
        ? this.withdrawMethod == 'BANK'
          ? Math.floor(Number(this.amount) - Math.ceil(Number(this.fee) * Number(this.rate)))
          : parseFloat((Number(this.amount) - Number(this.fee)) * this.rate).toFixed(2)
        : '--'
    },
    amountWithFee: function() {
      return this.amount && this.amount !== ''
        ? Math.ceil(Number(this.amount) - Number(this.fee))
        : '--'
    },
    advisableCreditAmountInCNY: function() {
      return this.advisableCreditAmount !== '' ? Math.floor(this.advisableCreditAmount * this.rate) : '--'
    },
    amountPlusFeeInUSD: function() {
      return this.amount !== '' && this.rate !== '' && this.fee !== '--' ? Math.round((Number(this.amount) / this.rate + Number(this.fee)) * 100) / 100 : '--'
    },
    feeInCNY: function() {
      return this.fee !== '' && this.fee !== '' ? Math.round(Number(this.fee) * this.rate) : '--'
    },
    filteredAmountOptionList: function() {
      return this.amountOptionList
    },
    isBankSubmitEnabled() {
      return this.amount != '' && 
             this.amount > 0 && 
             !this.isInvalidBankAndProv() && 
             !this.isInvalidBankInputAmount()
    },
    isUSDTSubmitEnabled() {
      return this.protocol !== 'BEP20' && 
             this.amount != '' && 
             this.amount > 0 && 
             this.walletAddress !== ''
    }
  },
  watch: {
    amount: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && newValue != '') {
          if (isNaN(newValue) || String(newValue).indexOf('-') >= 0) {
            this.amount = newValue.replace('-', '')
          }
          if (newValue.toString().split('.')[1]) {
            const fixed = newValue.toString().split('.')[1].length
            if (fixed > 2) {
              newValue
                .toString()
                .split('.')[1]
                .slice(0, 2)
              newValue =
                newValue.toString().split('.')[0] +
                '.' +
                newValue
                  .toString()
                  .split('.')[1]
                  .slice(0, 2)
              this.amount = newValue
            }
          }

          if (this.withdrawMethod === 'BANK') {
            if (parseFloat(newValue) > parseFloat(this.advisableCreditAmountInCNY)) {
              // this.amount = this.advisableCreditAmountInCNY
            }
          } else {
            if (parseFloat(newValue) > parseFloat(this.advisableCreditAmount)) {
              this.amount = this.advisableCreditAmount
            }
          }
          this.gettingFees = true
          this.delayTimer(() => {
            this.errMessage = ''
            this.feeData()
          })
          this.hasScrollbar()
        }
      }
    }
  },
  mounted() {
    this.initMounted()
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.hasScrollbar()
  },
  methods: {
    initMounted() {
      if (this.withdrawalData) this.$store.dispatch('setWithdrawalData', {})

      this.removeFixed()
      this.$bus.$emit('loading', true)
      window.scrollTo(0, 0)
      this.hasScrollbar()
      this.advisableCredit(0)
      this.initAmountOptionLists().then(() => this.getMinAmount())
      this.getWithdrawMethod()
      if (this.pageType == 'app' || this.sourceType == 'old') {
        this.checkFaceValidate()
      }

      this.maxWallets = MAX_WALLETS
      this.isButtonCertify = false
    },
    forceRerenderChildComponents() {
      this.depositAndWithdrawalKey++
    },
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    hasScrollbar() {
      if (
        document.body.scrollHeight >
        (window.innerHeight || document.documentElement.clientHeight)
      ) {
        this.isScroll = true
      } else this.isScroll = false
      return this.isScroll
    },
    goAddBankCard() {
      this.$bus.$emit('loading', false)
      if (this.withdrawList.length == 3) {
        this.$store.dispatch('setTabIndex', 0)
        this.$router.push({ path: '/home/bankList' })
      } else {
        this.$router.push({
          path: '/home/addBankCard',
          query: { bankType: 0 }
        })
      }
    },
    withdrawalNoticePop() {
      this.toggleFixed()
      this.isWithdrawalNoticePop = !this.isWithdrawalNoticePop
    },
    withdrawalInstructionsPop() {
      this.toggleFixed()
      this.isWithdrawalInstructionsPop = !this.isWithdrawalInstructionsPop
    },
    exchangeRate() {
      const data = {
        type: 2,
        sourceCurrency: this.currency,
        targetCurrency: this.targetCurrency
      }
      api.getRate(data).then((res) => {
        if (res.status) {
          if (res.data.code == 200) {
            this.rate = res.data.data
          }
        }
      })
    },
    withdrawBankList() {
      const arrList = []
      api.getWithdrawBankList().then((res) => {
        this.$bus.$emit('loading', true)
        if (res.status) {
          if (res.data.code == 200) {
            this.executeSwitchMethod('BANK')
            if (res.data.data.withdrawBankList) {
              const list = res.data.data.withdrawBankList
              for (const j in list) {
                if (list[j].approveStatus == 'APPROVAL') {
                  arrList.push(list[j])
                }
              }
              this.withdrawList = arrList

              this.onConfirmBank(arrList[0])
            }
          }
        }
      })
    },
    allWithdraw() {
      this.advisableCredit(1)
    },
    advisableCredit(type) {
      api.getAdvisableCredit(this.gts2AccountId).then((res) => {
        if (res.status) {
          if (res.data.code == 200) {
            if (type == 1) {
              this.amount = res.data.data.advisableCredit

              if (this.withdrawMethod === 'BANK') {
                this.amount = Math.floor(this.amount * this.rate)
              }
            }
            this.advisableCreditAmount = res.data.data.advisableCredit
          }
        }
      })
    },
    feeData(type) {
      if (type === 1) {
        this.$bus.$emit('loading', false)
      }
      const data = {
        gts2AccountId: this.gts2AccountId,
        accountNo: this.user.loginname,
        withdrewBankName: this.withdrawMethod === 'BANK' && this.selectedBank ? this.selectedBank.bank : '',
        withdrewBankAccount: this.withdrawMethod === 'BANK' && this.selectedBank ? this.selectedBank.bankAccountNumber : '',
        transAmount: parseFloat(this.amount),
        paymentType: this.withdrawMethod === 'BANK' ? 'REAL_CURRENCY' : 'VIRTUAL_CURRENCY'
      }
      api.getWithdrawFeeList(data).then((res) => {
        this.gettingFees = false
        if (res.status) {
          if (res.data.code == 200) {
            this.fee = res.data.data.totalFee
            if (type == 1) {
              const data = {
                gts2AccountId: this.gts2AccountId,
                accountNo: this.user.loginname,
                transAmount: parseFloat(this.amount),
                advisableCredit: this.advisableCreditAmount,
                platform: this.platform,
                isFaceValidate: this.isFaceValidate
              }
              this.withdrawValidate(data)
            }
          }
        }
      })
    },
    getFaceVal(data) {
      this.isFaceValidate = data
    },
    checkFaceValidate() {
      if (this.sourceType == 'old') {
        this.isFaceValidate = false
      } else this.isFaceValidate = true
    },
    async withdrawValidate(data) {
      const isValid = await this.isValidateMinAmount()
      if (isValid === null) return
      if (!isValid) {
        if (this.withdrawMethod === 'USDT') {
          this.errMessage = `扣除手续费后需达到${this.minAmount.usdt}美元以上`
        } else {
          this.errMessage = `扣除手续费后需达到${
            this.minAmount.bank
          }人民币以上`
        }
        this.$bus.$emit('loading', true)
        return
      }
      if (this.withdrawMethod === 'USDT') {
        data = {
          ...data,
          transCurrency: 'USDT',
          paymentType: 'VIRTUAL_CURRENCY',
          walletCompany: this.walletCompany,
          protocol: this.protocol,
          walletAddress: this.walletAddress,
          isUSDT: true,
          amount: Number(this.amount),
          fee: this.fee,
          rate: this.rate,
          chainType: this.chainType,
          isFaceValidate: this.isFaceValidate
        }
      } else {
        const amount = Number(this.amount)
        data = {
          ...data,
          transCurrency: 'CNY',
          paymentType: 'REAL_CURRENCY',
          withdrewBankName: this.selectedBank ? this.selectedBank.bank : '',
          withdrewBankNameInCh: this.selectedBank ? this.selectedBank.bankName : '',
          withdrewBankAccount: this.selectedBank ? this.selectedBank.bankAccountNumber : '',
          isUSDT: false,
          amount: amount,
          fee: Number(this.fee),
          rate: this.rate,
          isFaceValidate: this.isFaceValidate,
          isMatching: this.isMatching
        }
      }

      api.withdrawDataValidate(data).then((res) => {
        if (res.status) {
          if (res.data.code == 200 && res.data.code_desc == 'success') {
            this.$store.dispatch('setWithdrawalData', data)
            this.$router.push({ path: '/home/withdrawalConfirm' })
          } else if (res.data.code == 1011) {
            this.buttonData = res.data.data
            this.isButtonCertify = true
          } else {
            this.$bus.$emit('loading', true)
            this.errMessage = res.data.code_desc
          }
        }
      })
    },
    async submit() {
      if (this.isInvalidBankAndProv()) {
        return
      }

      try {
        this.$bus.$emit('loading', false)

        // 1. Call canWithdrawal API for BOTH types concurrently
        const [bankCheck, usdtCheck] = await Promise.all([
          api.getCanWithdraw('REAL_CURRENCY'),
          api.getCanWithdraw('VIRTUAL_CURRENCY')
        ])

        // 2. Update state for both flags so the popup component knows exactly which buttons to render
        this.canWithdraw.bank = bankCheck.data.data.result
        this.canWithdraw.usdt = usdtCheck.data.data.result

        // 3. Evaluate conditional popup logic
        // If the current selected method is false, halt and show the popup.
        if (
          (this.withdrawMethod === 'USDT' && !this.canWithdraw.usdt) ||
          (this.withdrawMethod === 'BANK' && !this.canWithdraw.bank)
        ) {
          this.showAlertPop = true
          this.$bus.$emit('loading', true)
          return
        }

        // 4. Continue with specific submit logic since the selected method is allowed
        if (this.withdrawMethod === 'USDT') {
          if (
            this.protocol !== 'BEP20' &&
            this.amount !== '' &&
            this.amount > 0 &&
            this.walletAddress !== ''
          ) {
            await this.getMaxAmount()
            
            if (this.maxAmount.usdt > -1 && Number(this.ratedAmountWithFee) > this.maxAmount.usdt) {
              this.errMessage = `目前取款金额不可超过${this.maxAmount.usdt}${this.getDisplayCurrencyText(this.targetCurrency)}以上`
              this.$bus.$emit('loading', true) 
              return
            } 
            
            this.errMessage = ''
            this.feeData(1)
            
          } else {
            this.$bus.$emit('loading', true)
          }

        } else {
          // BANK Logic
          if (this.amount != '' && this.amount > 0) {
            if (this.isInvalidBankInputAmount()) {
              this.$bus.$emit('loading', true) 
              return
            }

            await this.getMaxAmount()

            if (this.maxAmount.bank > -1 && Number(this.amount) > this.maxAmount.bank) {
              this.errMessage = `目前取款金额不可超过${this.maxAmount.bank}${this.getDisplayCurrencyText(this.targetCurrency)}以上`
              this.$bus.$emit('loading', true) 
              return
            } 
            
            this.errMessage = ''
            this.feeData(1)

          } else {
            this.$bus.$emit('loading', true)
          }
        }
      } catch (error) {
        this.$bus.$emit('loading', true)
        this.errMessage = '网络请求失败，请稍后再试'
        console.error('Failed to verify withdrawal status:', error)
      }
    },
    // Handles fetching statuses via API when tabs are directly clicked
    async switchWithdrawMethod(method) {
      try {
        this.$bus.$emit('loading', false)
        const [canBank, canUsdt] = await Promise.all([
          api.getCanWithdraw('REAL_CURRENCY'),
          api.getCanWithdraw('VIRTUAL_CURRENCY')
        ])

        this.canWithdraw.bank = canBank.data.data.result
        this.canWithdraw.usdt = canUsdt.data.data.result

        this.$bus.$emit('loading', true)

        if (!this.canWithdraw[method.toLowerCase()]) {
          this.showAlertPop = true
          return
        }

        this.executeSwitchMethod(method)
      } catch (error) {
        this.$bus.$emit('loading', true)
        console.error('Failed to get withdraw status', error)
      }
    },
    // The visual swap / variable reset logic separated out so it can be called internally
    executeSwitchMethod(method) {
      this.selectedAmountOptionIndex = -1
      this.isMatching = true
      this.withdrawMethod = method
      this.amount = ''
      this.errMessage = ''
      
      if (method === 'USDT' && this.walletList.length > 0) {
        this.switchWallet(0)
      } else if (method === 'BANK') {
        this.targetCurrency = 'CNY'
        this.exchangeRate()
        this.onConfirmBank(this.withdrawList.length > 0 && this.withdrawList[0])
      }
    },
    getWithdrawMethod() {
      this.$bus.$emit('loading', false)
      api.getWithdrawMethod().then((res) => {
        if (res.data.code === 200) {
          this.useUSDT = res.data.data.fictitious
          this.useBank = res.data.data.legal
          Promise.all([
            api.getCanWithdraw('REAL_CURRENCY'),
            api.getCanWithdraw('VIRTUAL_CURRENCY')
          ]).then(([canBank, canUsdt]) => {
            this.canWithdraw.bank = canBank.data.data.result
            this.canWithdraw.usdt = canUsdt.data.data.result
            if (this.useBank) {
              if (!this.canWithdraw.bank) {
                this.showAlertPop = true
              } else {
                this.withdrawBankList()
              }
            }
            if (this.useUSDT) {
              if (!this.canWithdraw.usdt) {
                this.showAlertPop = true
              } else {
                this.getWalletList()
              }
            }
            if (!this.useUSDT && !this.useBank) {
              this.showAlertPop = true
            }
          }).catch(() => {
            this.withdrawBankList()
            this.getWalletList()
          })
        }
      })
    },
    getWalletList() {
      api.getWalletList().then((res) => {
        this.$bus.$emit('loading', true)
        if (res.data.code === 200) {
          this.walletList = res.data.data
          if (!this.canWithdraw.bank || !this.useBank) {
            this.executeSwitchMethod('USDT')
          }
        }
      })
    },
    toggleAddWallet() {
      this.$router.push({ path: '/home/RegisterUSDT', query: { fromWithdraw: 1 }})
    },
    switchWallet(index) {
      this.walletAddress = this.walletList[index].walletAddress
      this.walletCompany = this.walletList[index].walletCompany
      this.protocol = this.walletList[index].protocol
      if (this.protocol == 'BEP20') {
        this.showBEP20WarningPop = true
      }
      this.targetCurrency = this.walletList[index].walletCurrency
      this.selectedWalletIdx = index
      this.exchangeRate()
    },
    alertOnClose() {
      this.showAlertPop = false
      if (this.canWithdraw.bank) {
        this.executeSwitchMethod('BANK')
      } else if (this.canWithdraw.usdt) {
        this.executeSwitchMethod('USDT')
      }
    },
    initAmountOptionLists() {
      this.$bus.$emit('loading', false)
      return api.matchAmountSetting(0).then((res) => {
        this.$bus.$emit('loading', true)
        if (res.data.code == 200) {
          this.amountOptionList = res.data.data[0].amounts.map(amount => amount.key)
          this.noMatchAmountOptionList = [...res.data.data[0].amounts.map(amount => amount.key).filter(val => val < 3000), 3000]
        }
        return res
      })
    },
    getMinAmount() {
      try {
        return new Promise((resolve) => {
          api
            .getMinWithdraw()
            .then((res) => {
              if (res.status !== 200) {
                resolve(null)
                return
              }
              const { data } = res.data
              this.minAmount.bank = data.minWithdrawAmt
              this.minAmount.usdt = data.minWithdrawUsdtAmt
              resolve(this.minAmount)
            })
            .catch((error) => {
              resolve(null)
              console.error(error)
            })
        })
      } catch (error) {
        console.error(error)
      }
    },
    isValidateMinAmount() {
      return new Promise((resolve) => {
        if (this.withdrawMethod === 'USDT') {
          if (this.minAmount.usdt === null) {
            this.getMinAmount().then((res) => {
              if (res === null) {
                this.errMessage = '網路錯誤(000)'
                return resolve(null)
              }
            })
          } else {
            return resolve(Number(this.amountWithFee) >= this.minAmount.usdt)
          }
        } else {
          if (this.minAmount.bank === null) {
            this.getMinAmount().then((res) => {
              if (res === null) {
                this.errMessage = '網路錯誤(000)'
                return resolve(null)
              }
            })
          } else {
            return resolve(
              Number(this.amount) >= this.minAmount.bank
            )
          }
        }
      })
    },
    getMaxAmount() {
      try {
        return new Promise((resolve) => {
          api.getMaxWithdraw()
            .then((res) => {
              if (res.status !== 200) {
                resolve(false)
                return
              }
              const { data } = res.data
              this.maxAmount.usdt = data.maxWithdrawUsdtAmt
              this.maxAmount.bank = data.maxWithdrawAmt
              resolve(true)
            })
        })
      } catch (error) {
        console.error(error)
      }
    },
    delayTimer(callback, ms = 500) {
      clearTimeout(this.timer)
      this.timer = setTimeout(callback, ms)
    },
    closeBankProvWarningPop() {
      this.showBankProvWarningPop = false
    },
    closeNoMatchOnlyBankWarningPop() {
      this.showNoMatchOnlyBankWarningPop = false
    },
    closeBEP20WarningPop() {
      this.showBEP20WarningPop = false
    },
    isInvalidBankAndProv(callback) {
      if (this.withdrawMethod == 'BANK' && this.selectedBank && this.selectedBank.bank == 'ICBKCNBJXXX' && this.selectedBank.bankProvince == 'guangdong') {
        if (callback) callback()
        return true
      }

      return false
    },
    isNoMatchOnlyBank(callback) {
      if (this.withdrawMethod == 'BANK' && this.selectedBank && (this.selectedBank.bankName.includes('工商') || this.selectedBank.bankName.includes('农业'))) {
        setTimeout(() => {
          if (callback) callback()
          this.showNoMatchOnlyBankWarningPop = true
        }, 2000) 
        return true
      }
      return true
    },
    selectAmountOption(amountOption, index) {
      this.selectedAmountOptionIndex = index
      if (this.selectedAmountOptionIndex <= this.amountOptionList.length - 1) {
        this.amount = amountOption
      } else {
        this.amount = ''
      }
    },
    selectNoMatchAmountOption(noMatchAmountOption, index) {
      this.selectedNoMatchAmountOptionIndex = index
      if (this.selectedNoMatchAmountOptionIndex < this.noMatchAmountOptionList.length - 1) {
        this.amount = noMatchAmountOption
      } else {
        this.amount = ''
      }
    },
    isInvalidBankInputAmount() {
      if (this.withdrawMethod != 'BANK') {
        return false
      }

      if (this.isMatching) {
        return this.selectedAmountOptionIndex == -1
      }

      return this.selectedNoMatchAmountOptionIndex == -1 ||
        this.selectedNoMatchAmountOptionIndex == this.noMatchAmountOptionList.length - 1 &&
      this.amount <= Math.max(...this.noMatchAmountOptionList)
    },
    onKeyUp(event) {
      if (this.withdrawMethod == 'BANK') {
        event.target.value = event.target.value.replace(/\.\d+/, '')
      }
    },
    onConfirmAccount() {
      this.initMounted()
      this.forceRerenderChildComponents()
    },
    onConfirmBank(bank) {
      this.isInvalidBankAndProv(() => (this.showBankProvWarningPop = true))
      this.isNoMatchOnlyBank(() => (this.showNoMatchOnlyBankWarningPop = true))

      if (!bank) {
        return
      }

      this.selectedBank = bank

      if (this.selectedBank.bank === 'alipay') {
        this.selectedWithdrawalType = 'customAmt'
        this.selectBankMatchWithdrawal(false)
      } else {
        this.selectedWithdrawalType = 'fixedAmt'
        this.selectBankMatchWithdrawal(true)
      }

      if (this.amount && this.amount != '') this.feeData()
    },
    selectBankMatchWithdrawal(match) {
      if (this.withdrawMethod === 'BANK') {
        this.isMatching = match
      }
    }
  }
}
</script>